export const defaultDebounceInterval = 750;
//# sourceMappingURL=debounce.js.map